import { call, select } from 'redux-saga/effects';
import { loadFileListWorker } from './loadFileListWorker';
import { getCompanyLibrary } from '../selectors';
import { CompanyLibraryState } from '../reducers';

export function* onPusherFileUpdatedWorker() {
  const { activeSalesOpts } = (yield select(getCompanyLibrary)) as CompanyLibraryState;
  yield call(loadFileListWorker, {
    payload: { isInitialRender: false, clientContractOpts: activeSalesOpts ?? undefined },
  } as any);
}
